import { Modal, Group, Button, Text } from '@mantine/core';
import { HttpError } from '@refinedev/core';
import { User } from '../types';

type DeleteUserModalProps = {
  user: User | null;
  onClose: () => void;
  onDeleteConfirm: () => void;
  error?: HttpError | null;
};

export default function DeleteUserModal({
  user,
  onClose,
  onDeleteConfirm,
  error,
}: DeleteUserModalProps) {
  return (
    <Modal opened={!!user} onClose={onClose} title="Delete user" centered>
      <Text mb="md">
        Are you sure you want to delete {user?.firstName} {user?.lastName}? This action cannot be
        undone.
      </Text>
      {error && (
        <Text c="red" mb="md">
          {error.message ?? 'An error occurred deleting the user'}
        </Text>
      )}
      <Group justify="flex-end">
        <Button variant="subtle" onClick={onClose}>
          Cancel
        </Button>
        <Button color="red" onClick={onDeleteConfirm}>
          Delete
        </Button>
      </Group>
    </Modal>
  );
}
